import * as Yup from 'yup'

export const schemaQuotationRequest = (t: (key: string) => string) => ({
  status: Yup.string().required(t('requiredMessage')),
  refusedReason: Yup.string().required(t('requiredMessage')),
})
